import { useCoreConfig, defineNuxtRouteMiddleware, useNuxtApp, useRequestURL, useTracking } from '#imports'

export default defineNuxtRouteMiddleware((to, from) => {
    if (import.meta.server) return

    const { isHydrating } = useNuxtApp()
    const { trackPageRequest } = useTracking()
    const { origin } = useRequestURL()
    const { trackingService } = useCoreConfig()

    // Only track when there is a real page change. Ignore first request.
    if (!isHydrating && to.path === from.path) {
        return
    }

    if (!trackingService?.enabled) return

    const url = new URL(to.fullPath, origin)

    trackPageRequest({ url: url.href, referer: document.referrer })
})
